import { Component, OnInit } from '@angular/core';
import { DisordersService } from 'src/app/service/http-services/disorders.service';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.css']
})
export class WelcomePageComponent implements OnInit {

  disorders: string[] = [
    "Acute stress disorder",
    "Addiction",
    "Adjustment disorder",
    "Agoraphobia",
    "Anorexia",
    "Antisocial",
    "Anxiety",
    "ADHD",
    "Autism",
    "Bereavement",
    "Binge eating",
    "Bipolar disorder",
    "Body dysmorphia",
    "Borderline personality disorder",
    "Bulimia",
    "Chronic stress exposure",
    "Conversion disorder",
    "Cyclothymic disorder",
    "Delusional disorder",
    "Dementia/Alzheimer",
    "Depersonalisation disorder",
    "Depression",
    "Dissociative amnesia",
    "Dissociative disorders",
    "Identity disorder (MPD)",
    "Early psychosis/Psychosis",
    "Eating disorders",
    "Erectile disorder",
    "Exhibitionism",
    "Family problems",
    "Gender dysphoria",
    "Hypersomnia",
    "Hypochondria",
    "Insomnia",
    "Intelectuall disability",
    "Kleptomania",
    "I just feel lonely",
    "Major depressive disorder (MDD)",
    "Narcolepsy",
    "Nightmare/Sleep Terrors",
    "Obsessive compulsive disorder (OCD)",
    "Orgasmic disorders",
    "Panic attacks",
    "Paranoid",
    "Gambling addiction",
    "Posttraumatic stress disorder (PTSD)",
    "Premature ejaculation",
    "Tic disorder",
    "Psychotic disorder",
    "Pyromania",
    "Relationship problems",
    "Sleep rythm disturbances",
    "Schizoaffective disorder",
    "Schizoid personality disorder",
    "Schizophrenia",
    "School problems",
    "Seasonal affectiveness",
    "Low self esteem",
    "Self injury",
    "Separation anxiety",
    "Sexual arousal disorder",
    "Sexual dysfunction",
    "Shared psychotic disorder",
    "Short term memory loss",
    "Sleepwalking",
    "Social anxiety",
    "Somatic symptoms",
    "Stuttering",
    "Substance abuse",
    "Suicidal",
    "Childhood abuse",
    "Domestic violence",
    "Emotional abuse",
    "Rape survivor",
    "Tourette disorder",
    "Trauma/Accident survivor",
    "Trichotillomania",
    "Violence victim",
    "Work problems"
  ];

  constructor(private disorderService: DisordersService) { }

  ngOnInit(): void {
  }


}
